import axios from 'axios'
import { Fragment, useCallback, useEffect, useState } from 'react'
import config from '../../config'
import Cookies from 'js-cookie'
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import { transformBuddhistDateToChristianDate } from '../../helpers/helpers'
import PrizeItems from './components/PrizeItems'
import { PRIZE_SOURCE, PRIZE_STATES, RESULT_KEY_LIST } from '../../constants/prizes'

const PrizeInputsPage = ({ selectedRound, state, getStates }) => {
  const [results, setResults] = useState(null)
  const [sanookResults, setSanookResults] = useState(null)
  const roundDate = new Date(transformBuddhistDateToChristianDate(selectedRound.value)).toLocaleDateString('th', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  })
  const handleClickDraftPrize = async () => {
    const result = await axios.post(
      `${config.apiAdminGateway}/api/v2/prizes/results`,
      {
        source: PRIZE_SOURCE.MANUAL,
        roundDate: selectedRound?.value,
      },
      {
        headers: {
          Authorization: `Bearer ${Cookies.get('accessToken')}`,
        },
      },
    )

    if (result.data.status.code === 0) {
      await getResult()
    } else {
      await getStates()
    }
  }

  const getResult = useCallback(async () => {
    const result = await axios.get(
      `${config.apiAdminGateway}/api/v2/prizes/results?source=${PRIZE_SOURCE.MANUAL}&roundDate=${selectedRound?.value}`,
      {
        headers: {
          Authorization: `Bearer ${Cookies.get('accessToken')}`,
        },
      },
    )

    if (result.data.status.code === 0) {
      setResults(result.data.data)
      setSanookResults(null)
      return
    }

    if (result.data.status.code === 1002) {
      setResults(null)
      setSanookResults(null)
      await getStates()
    }
  }, [getStates, selectedRound?.value])

  const getResults = useCallback(async () => {
    const result = await axios.get(
      `${config.apiAdminGateway}/api/v2/prizes/results/${selectedRound?.value}/round-date`,
      {
        headers: {
          Authorization: `Bearer ${Cookies.get('accessToken')}`,
        },
      },
    )

    if (result.data.status.code === 0) {
      const { data } = result.data
      const manual = data.find((item) => item.source === PRIZE_SOURCE.MANUAL)
      const sanook = data.find((item) => item.source === PRIZE_SOURCE.SANOOK)
      setResults(manual)
      setSanookResults(sanook)
    }

    if (result.data.status.code === 1002) {
      setResults(null)
      setSanookResults(null)
      await getStates()
    }
  }, [getStates, selectedRound?.value])

  const updateDraftResult = async (prizeType, index, value) => {
    try {
      const body = {
        prizeType: prizeType.toUpperCase(),
        index: index,
        value: value,
        roundDate: selectedRound?.value,
        source: PRIZE_SOURCE.MANUAL,
      }
      const response = await axios.post(`${config.apiAdminGateway}/api/v2/prizes/draft-results`, body, {
        headers: {
          Authorization: `Bearer ${Cookies.get('accessToken')}`,
        },
      })
      if (response.data.status.code === 0) {
        await getResult()
      } else {
        await getStates()
      }
    } catch (error) {
      console.error(error)
    }
  }

  const updateResult = async (prizeType, source, index, value) => {
    try {
      const body = {
        prizeType: prizeType.toUpperCase(),
        index: index,
        value: value,
        roundDate: selectedRound?.value,
        source: source,
      }
      const response = await axios.put(`${config.apiAdminGateway}/api/v2/prizes/results`, body, {
        headers: {
          Authorization: `Bearer ${Cookies.get('accessToken')}`,
        },
      })
      if (response.data.status.code === 0) {
        await getResults()
      } else {
        await getResults()
        await getStates()
      }
    } catch (error) {
      console.error(error)
      await getResults()
    }
  }

  const handleClickConfirmPrize = async () => {
    const result = await axios.post(
      `${config.apiAdminGateway}/api/v2/prizes/results/confirm`,
      {
        roundDate: selectedRound?.value,
      },
      {
        headers: {
          Authorization: `Bearer ${Cookies.get('accessToken')}`,
        },
      },
    )

    if (result.data.status.code === 0) {
      await getStates()
    } else {
      await getStates()
      await getResults()
    }
  }

  useEffect(() => {
    if (state === PRIZE_STATES.NONE) {
      getResult()
    } else if (state === PRIZE_STATES.RESULT_CREATED) {
      getResults()
    }
  }, [getResult, getResults, state])

  if (!results) {
    return (
      <Fragment>
        <Card.Body
          className="d-flex justify-content-center"
          style={{
            minHeight: '400px',
          }}
        >
          <Card.Title as="h2">ยังไม่มีผลรางวัลประจำงวดวันที่ {roundDate}</Card.Title>
        </Card.Body>
        <Card.Footer className="d-flex justify-content-center">
          <Button onClick={handleClickDraftPrize}>เริ่มกรอกรางวัล</Button>
        </Card.Footer>
      </Fragment>
    )
  }

  return (
    <Fragment>
      <Card.Body
        style={{
          minHeight: '400px',
        }}
      >
        <Card.Title
          as="h2"
          className="d-flex justify-content-center"
          style={{
            fontSize: '1.5rem',
          }}
        >
          ผลรางวัลประจำงวดวันที่ {roundDate}
        </Card.Title>
        {results && (
          <div>
            {Object.keys(results).map((key) => {
              if (!RESULT_KEY_LIST.includes(key)) return null
              return (
                <PrizeItems
                  key={key}
                  prizeType={key}
                  result={results[key]}
                  sanookResult={sanookResults ? sanookResults[key] : null}
                  updateDraftResult={updateDraftResult}
                  updateResult={updateResult}
                />
              )
            })}
          </div>
        )}
      </Card.Body>
      <Card.Footer className="d-flex justify-content-center">
        <Button variant="primary" disabled={state !== PRIZE_STATES.RESULT_CREATED} onClick={handleClickConfirmPrize}>
          ยืนยันผล
        </Button>
      </Card.Footer>
    </Fragment>
  )
}

export default PrizeInputsPage
